import * as React from 'react';
import * as styles from '../styles.scss';
import { Fallback } from 'components/common';
import { IState } from 'redux/global-reducers';
import * as classNames from 'classnames';
import { WithNamespaces, withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { handleError } from 'utils/common';
import { withErrorBoundary } from 'react-error-boundary';
import { IOrderFormConfig, OrderFormFieldKey } from '../config';

interface IBuySellSectionProps
  extends React.ClassAttributes<BuySellComponent>,
    WithNamespaces {
  readonly config: IOrderFormConfig;
  readonly buyType: boolean;
  readonly sellType: boolean;
  readonly containerRef: React.RefObject<HTMLDivElement>;
  readonly onChangeBuyType: () => void;
  readonly onChangeSellType: () => void;
}

class BuySellComponent extends React.Component<IBuySellSectionProps> {
  render() {
    const {
      t,
      config,
      containerRef,
      buyType,
      sellType,
      onChangeBuyType,
      onChangeSellType,
    } = this.props;
    return (
      <div
        className={classNames(styles.BuySellSection, styles.FormField)}
        style={config[OrderFormFieldKey.BUY_SELL]?.style}
        ref={containerRef}
      >
        <div className={styles.BuySellButton}>
          <div
            className={classNames(styles.BuyButton, {
              [styles.Active]: buyType,
            })}
            onClick={onChangeBuyType}
          >
            {t('BUY 2')}
          </div>
          <div
            className={classNames(styles.SellButton, {
              [styles.Active]: sellType,
            })}
            onClick={onChangeSellType}
          >
            {t('SELL 2')}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: IState) => ({});

const mapDispatchToProps = {};

const BuySellSection = withErrorBoundary(
  withNamespaces('common')(
    connect(mapStateToProps, mapDispatchToProps)(BuySellComponent)
  ),
  Fallback,
  handleError
);

export default BuySellSection;



// WEBPACK FOOTER //
// ./src/components/common/OrderForm/FormSection/BuySellSection.tsx